import useSWR from 'swr'

const fetcher = (...args: Parameters<typeof fetch>) =>
  fetch(...args).then((res) => res.json())

export const usePageViews = () => {
  // www.comparecredit.com/credit-cards/tips/pay-0-interest -> /credit-cards/tips/pay-0-interest/
  const path = window.location.pathname.replace(/([^/]+)\/?([^/]+)?/, '$1/$2')

  const { data, error, isLoading } = useSWR<{
    pageViews: number | null
  }>(`/api/get-page-views?path=${encodeURIComponent(path)}`, fetcher)

  const formattedPageViewCounts = data?.pageViews

  return {
    pageViews: formattedPageViewCounts,
    isLoading,
    isError: error,
  }
}
